import React from 'react'
import { Helmet } from 'react-helmet-async'

export const RegisterPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Register - Jewelry Inventory Tracker</title>
      </Helmet>
      <div className="text-center">
        <h1 className="text-2xl font-bold">Register</h1>
        <p>Registration page coming soon...</p>
      </div>
    </>
  )
}